export default __webpack_public_path__ + "static/media/SignHere.0c89de9e.svg";